import { render, staticRenderFns } from "./StepLabel.vue?vue&type=template&id=1d2c4d3b&scoped=true&"
import script from "./StepLabel.vue?vue&type=script&lang=ts&"
export * from "./StepLabel.vue?vue&type=script&lang=ts&"
import style0 from "./StepLabel.vue?vue&type=style&index=0&id=1d2c4d3b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2c4d3b",
  null
  
)

export default component.exports